import Features, { getFeaturesHeight } from './Features';
export { getFeaturesHeight };
export default Features;
